import request from '../utils/request';

export const add = (param) => {
    return request({
        url: '/sys/eventReminder/add',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
export const update = (param) => {
    return request({
        url: '/sys/eventReminder/update',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
export const uploadFile = (file) => {
    return request({
        url: '/sys/eventReminder/uploadFile',
        method: 'POST',
        data: file
    });
};
export const deleteEventReminder = (id) => {
    return request({
        url: '/sys/eventReminder/delete/'+id,
        method: 'POST',
        headers:{
            'Content-Type':'application/json;charset=UTF-8',
        }
    });
};
export const getEventReminderList = (param) => {
    return request({
        url: '/sys/eventReminder/getEventReminderList',
        method: 'POST',
        dataType: "json",
        data: JSON.stringify(param),
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
        }
    });
};
